import React from "react";
import { FaAngleLeft, FaAngleRight, FaEllipsisH } from "react-icons/fa";
import { usePagination, DOTS } from "./usePagination";

const NumberedPagination = ({
  onPageChange,
  totalCount,
  siblingCount = 1,
  currentPage,
  pageSize,
}) => {
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];
  return (
    <ul className="flex flex-row gap-1 justify-center items-center list-none flex-wrap">
      {/* Left navigation arrow */}
      <li
        className={`${
          currentPage === 1 ? "hidden" : "block"
        } text-textSecondary cursor-pointer h-8 w-8 hover:bg-black hover:bg-opacity-10 text-center rounded-full flex items-center justify-center`}
        onClick={onPrevious}
      >
        <FaAngleLeft />
      </li>

      {/* PAge numbers for navigation */}
      {paginationRange.map((pageNumber, index) => {
        if (pageNumber === DOTS) {
          return (
            <li key={index} className="text-textSecondary">
              <FaEllipsisH />
            </li>
          );
        }
        return (
          <li
            key={index}
            className={`${
              currentPage === pageNumber
                ? "bg-black bg-opacity-20"
                : "hover:bg-black hover:bg-opacity-10"
            } text-textSecondary font-medium cursor-pointer h-8 w-8 text-center rounded-full flex items-center justify-center`}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </li>
        );
      })}
      {/*  Right Navigation arrow */}
      <li
        className={`${
          currentPage === lastPage ? "hidden" : "block"
        } cursor-pointer h-8 w-8 hover:bg-black hover:bg-opacity-20 text-center rounded-full flex items-center justify-center text-textSecondary`}
        onClick={onNext}
      >
        <FaAngleRight />
      </li>
    </ul>
  );
};

export default NumberedPagination;
